import axios from 'axios';

const axios_ = axios.create({
	timeout: 60000 // ms
})

export default {
	data() {
		return {
			axios: axios_
		}
	}
}